export type AddEditDictProps = {
    dictDefinition: any,
    setDisableSaveBtn: Function,
    setDisableDeleteBtn: Function,
    setEditedDict?: Function,
    editedDict?: MutableDict[],
    setEditedDictRecord: Function,
    editedDictRecord?: MutableDict,
    setLoading: Function,
}

export type ManageDictEditionProps = {
    dictDefinition?: any,
    onClose: Function
}

export type MutableDict = {
    ID?: number,
    WARTOSC?: string,
    WARTOSC_EN?: string,
    WAZNY_OD?: Date | string,
    WAZNY_DO?: Date | string,
    KOLEJNOSC?: number,
    POPRZEDNIK?: number,

    // Custom fields
    KRYT_WYZN_TZ_GLOWNE_ID?: number | string
}

export enum ManageDictsViews {
    DictList,
    EditDict
}

export enum EditDictsViews {
    EditDict,
    AddRecord
}

export enum EditActiveBtnActions {
    Add,
    Edit,
    Delete
}